import { get } from 'svelte/store'
import { t } from '../../i18n/i18n'
import type { NewsConfig } from './news.types'

export const newsConfig: NewsConfig = {
	'ai-analysis': {
		validUntil: '2026-04-01T00:00:00Z', // TODO: make human-understandable (esp. Timezone)
		max_exposures: 3
	},
	'ai-analysis-check': {
		validUntil: '2026-04-01T00:00:00Z', // TODO: make human-understandable (esp. Timezone)
		max_exposures: 3
	},
	'ai-upload': {
		tooltip: {
			click_to_dismiss: true,
			badge: get(t)('UI.badge.newFunctionality'),
			badgeSuffix: '!',
			content: get(t)('UI.tooltip.newFunctionality.aiUpload')
		}
	}
}
